import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router";
import { Drawer, useTheme } from "@mui/material";
import StackKit from "@/shared/components/kit/stack";
import BoxKit from "@/shared/components/kit/box";
import AvatarUploader from "@/shared/components/common/avatar";
import TypoGraphyKit from "@/shared/components/kit/typoGraphy";
import { DataSidebar, SidebarItem } from "./data";
import LoginOutlinedIcon from "@mui/icons-material/LoginOutlined";
/**
 * SidebarMobile
 *
 * این کامپوننت نسخه موبایل سایدبار را پیاده‌سازی می‌کند و قابلیت نمایش منوها،
 * زیرمنوها، وضعیت فعال، و مدیریت ناوبری را فراهم می‌سازد. این سایدبار از Drawer
 * متریال‌یوآی استفاده کرده و با باز یا بسته شدن در حالت موبایل نمایش داده می‌شود.
 *
 * ویژگی‌ها:
 *
 * 1. **مدیریت وضعیت منو**  
 *    - تعیین آیتم فعال با توجه به مسیر جاری.  
 *    - باز و بسته کردن منوی والد در صورتی که دارای زیرمنو باشد.  
 *    - ناوبری بین صفحات با استفاده از React Router.
 *
 * 2. **نمایش اطلاعات کاربری**  
 *    - نمایش آواتار کاربر با استفاده از کامپوننت AvatarUploader.
 *
 * 3. **ساختار منو براساس DataSidebar**  
 *    - هر آیتم منو می‌تواند دارای آیکون، مسیر صفحه و زیرمنو باشد.  
 *    - زیرمنوها تنها زمانی نمایش داده می‌شوند که منوی والد باز باشد.
 *
 * 4. **هایلایت آیتم فعال**  
 *    - بررسی مسیر فعلی مرورگر و تنظیم وضعیت فعال برای منو و زیرمنو.  
 *    - تغییر رنگ و پس‌زمینه آیتم فعال با استفاده از Theme.
 *
 * 5. **خروج از حساب کاربری**  
 *    - پاک کردن اطلاعات کاربر از localStorage.  
 *    - انتقال کاربر به صفحه ورود.
 *
 * ورودی‌ها:
 * @param setOpenDrawer - تابع برای تغییر وضعیت باز یا بسته بودن سایدبار.
 * @param openDrawer - مشخص می‌کند که Drawer باز است یا بسته.
 *
 * @returns JSX.Element
 */

const SidebarMobile = ({setOpenDrawer,openDrawer,}: { setOpenDrawer: any; openDrawer: boolean;}) => {
  const [activeItemId, setActiveItemId] = useState<string | null>(null);
  const [openParentId, setOpenParentId] = useState<string | null>(null);
  const theme = useTheme();
  const navigate = useNavigate();
  const location = useLocation();

  const handleClick = (item: SidebarItem) => {
    if (item.children && item.children.length > 0) {
      setOpenParentId((prev) => (prev === item.id ? null : item.id));
    } else {
      setActiveItemId(item.id);
      navigate(item.path);
      setOpenDrawer(false);
    }
  };

  useEffect(() => {
    DataSidebar.forEach((item) => {
      if (item.path === location.pathname) {
        setActiveItemId(item.id);
        setOpenParentId(null);
      }
      item.children?.forEach((child) => {
        if (child.path === location.pathname) {
          setActiveItemId(child.id);
          setOpenParentId(item.id);
        }
      });
    });
  }, [location.pathname]);

  const handleLogout = () => {
    localStorage.removeItem("userPhone");
    localStorage.removeItem("ID");
    localStorage.removeItem("newrole");
    localStorage.removeItem("roleEnter");
    localStorage.removeItem("token");
    localStorage.removeItem("tokenbest");
    localStorage.removeItem("refreshToken");
    navigate("/login");

  };
  return (
    <>
      <Drawer anchor="top" open={openDrawer} onClose={() => setOpenDrawer(false)} PaperProps={{sx: {height: "100vh",bgcolor: "#0B0B0B",color: "#fff",padding: 2,direction: "rtl",width: 300,},}}>
        <BoxKit sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
          <AvatarUploader />
        </BoxKit>

        <StackKit direction="column" sx={{ width: "100%" }}>
          {DataSidebar.map((item) => {
            const isParentActive =
              activeItemId === item.id || openParentId === item.id;

            return (
              <React.Fragment key={item.id}>
                <BoxKit onClick={() => handleClick(item)} 
                  sx={{padding: "10px",fontWeight: "bold",backgroundColor: isParentActive ? theme.palette.primary.main : "transparent",color: isParentActive ? "#fff" : "#ccc",display: "flex",alignItems: "center",borderRadius: "8px",cursor: "pointer",gap: 1,transition: "background-color 0.3s ease",}}>
                  <span>{item.icon}</span>
                  <TypoGraphyKit variant="body1" sx={{ fontSize: "14px", fontWeight: "500", ml: 1 }}>
                    {item.title}
                  </TypoGraphyKit>
                </BoxKit>

                {item.children && openParentId === item.id && (
                  <StackKit direction="column" sx={{ pl: 3 }}>
                    {item.children.map((child) => (
                      <BoxKit key={child.id} onClick={() => handleClick(child)} sx={{padding: "6px 10px",fontWeight: "normal",backgroundColor: activeItemId === child.id ? theme.palette.primary.main : "transparent",color: activeItemId === child.id ? "#fff" : "#aaa",borderRadius: "6px",cursor: "pointer",transition: "background-color 0.3s ease",}}>
                        <TypoGraphyKit variant="body1" sx={{ fontSize: "12px", fontWeight: "400" }}>
                          {child.title}
                        </TypoGraphyKit>
                      </BoxKit>
                    ))}
                  </StackKit>
                )}
              </React.Fragment>
            );
          })}
           <BoxKit mt={4} onClick={handleLogout} sx={{cursor: "pointer",color: "red",display: "flex",alignItems: "center",gap: 1,}}>
            <LoginOutlinedIcon />
            <span>خروج</span>
          </BoxKit>
        </StackKit>
      </Drawer>
    </>
  );
};

export default SidebarMobile;
